import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Beranda from "@/pages/Beranda";
import BerandaMember from "@/pages/BerandaMember";
import Transaksi from "@/pages/Transaksi";
import Hutang from "@/pages/Hutang";
import Tabungan from "@/pages/Tabungan";
import Rekening from "@/pages/Rekening";
import MutasiRekening from "@/pages/MutasiRekening";
import Monitor from "@/pages/Monitor";

function RoleRoute() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  if (user.role === "member") return <BerandaMember />;
  return <Beranda />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<RoleRoute />} />
            <Route path="/transaksi" element={<Transaksi />} />
            <Route path="/hutang" element={<Hutang />} />
            <Route path="/tabungan" element={<Tabungan />} />
            <Route path="/rekening" element={<Rekening />} />
            <Route path="/rekening/:id/mutasi" element={<MutasiRekening />} />
            <Route path="/monitor" element={<Monitor />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}
export default App;